export default "__VITE_ASSET__DFjxNEIL__"